module.exports = __webpack_public_path__ + "img/gth_gbt2089_1994_right.prt.fba4960d.jpg";